export const assessment_update = {
  pre_update_changes_filename:
    "Pre_Mise_a_jour_{{preVersion}}_vers_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  post_update_changes_filename:
    "Post_Mise_a_jour_{{preVersion}}_vers_{{postVersion}}_{{assessment}}_{{tenant}}_{{dateTime}}.xlsx",
  "Are_you_sure_you_want_to_migrate?": "Êtes-vous sûr de vouloir migrer ?",
  Assessment_Update_Dry_Run: "Mise à jour d'évaluation",
  Assessment_Update_List: "Liste de mise à jour d'évaluation",
  Back_to_list: "Retour à la liste",
  Completed: "Terminé",
  Created: "Créé",
  Current_protocol_set_mapping_version: "Version actuelle du mappage de protocole",
  Deleted: "Supprimé",
  Download_JSON: "Télécharger JSON",
  Dry_Run: "Exécution à blanc",
  Has_data: "A des données",
  Inactive: "Inactif",
  Is_renamed: "Est renommé",
  Migrate: "Procéder",
  Migrated: "Migré",
  No_changes: "Aucun changement",
  No_changes_needed: "Aucun changement nécessaire",
  Protocol_Question_Name: "Nom de la question de protocole",
  Protocol_Question_New_Name: "Nouveau nom de la question de protocole",
  Protocol_Question_Old_Name: "Ancien nom de la question de protocole",
  protocol_set_changes: "Modifications de l'ensemble de protocoles",
  Site_name: "Nom du site",
  Stakeholder_Report: "Rapport des parties prenantes",
  Technical_Report: "Rapport technique",
  There_are_no_assessments_for_this_tenant: "Il n'y a aucune évaluation pour ce locataire",
  To_create: "À créer",
  To_delete: "À supprimer",
  To_migrate: "À migrer",
  Update: "Mettre à jour",
  Upgrade_to_latest: "Mettre à niveau vers la dernière version",
  assessment_is_already_updated: "L'évaluation est déjà mise à jour",
  show_history: "Afficher l'historique",
} as const;
